export default "__VITE_PUBLIC_ASSET__7b894ded__"